import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DBService } from '../../services/db.service';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})
export class ContactsComponent implements OnInit {

  loading: boolean;
  companyUID: string;

  constructor(private router: Router, private dbService: DBService, private route: ActivatedRoute) { 
    this.loading = true;

    this.route.params
    .subscribe(params => this.initData(params['id']));
  }

  ngOnInit() {

  }

  private initData(companyUID: string) {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/contacts.component.ts